<template>
  <div>
    <a-row>
      <a-col
        :xs="{ span: 24 }"
        :sm="{ span: 24 }"
        :md="{ span: 24 }"
        :xl="{ span: 20, offset: 2 }"
        :lg="{ span: 20, offset: 2 }"
        style="margin-top: 10px"
      >
        <div class="card-container">
          <a-tabs type="card" defaultActiveKey="1">
            <a-tab-pane key="1" tab="Cancer hallmarks">
              <a-row>
                <a-col
                  :span="24"
                  style="
                    font-size: 20px;
                    font-weight: bolder;
                    color: black;
                    margin-top: 5px;
                  "
                >
                  <a-icon type="forward" /> Select a phenotype
                </a-col>
                <a-col :span="24">
                  <a-select
                    style="width: 100%; margin-top: 10px"
                    @search="handleSearch"
                    @change="handleChange"
                    show-search
                    size="large"
                    :filter-option="true"
                    :value="value"
                  >
                    <a-select-option
                      v-for="item in options"
                      :key="item"
                      :value="item"
                    >
                      {{ item }}
                    </a-select-option>
                  </a-select></a-col
                >
                <!-- <a-col
                  :span="24"
                  style="
                    font-size: 20px;
                    font-weight: bolder;
                    color: black;
                    margin-top: 10px;
                  "
                >
                  <a-icon type="forward" /> Phenotype-responsive genes based on
                  scoring
                </a-col> -->
                <a-col
                  :span="24"
                  style="
                    font-size: 20px;
                    font-weight: bolder;
                    color: black;
                    margin-top: 10px;
                  "
                >
                  <cin v-if="this.value.includes('Genomic instability')" />
                  <genelist v-else v-bind:value="this.value" />
                </a-col>
              </a-row>
            </a-tab-pane>
          </a-tabs>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import genelist from "./genelist.vue";
import cin from "./CIN.vue";

export default {
  components: { genelist, cin },
  data() {
    return {
      options: [
        "Hallmark - Tumor metabolic reprogramming ( TMR )",
        "Hallmark - Activating invasion and metastasis ( AIM )",
        "Hallmark - Resisting cell death ( RCD )",
        "Hallmark - Sustaining proliferative signaling ( SPS )",
        "Hallmark - Genomic instability ( GI )",
        "Hallmark - Enabling replicative immortailty ( ERI )",
        "Hallmark - Unlocking phenotypic plasticity ( UPP )",
        "Hallmark - Angiogenesis ( Angiogenesis )",
        // "Hallmark - Avoiding immune destruction ( AID )",
        // "Mitochondrial respiratory chain ( MRC )",
        // "Unfolded protein response ( UPR )",
        // "Oxidative phosphorylation ( OXPHO )",
        // "Ribosome biogenesis ( RIBI )",
      ],
      value: "Hallmark - Tumor metabolic reprogramming ( TMR )",
    };
  },
  methods: {
    //搜索框
    handleChange(value) {
      this.value = value;
    },
  },
};
</script>

<style>
.h1 {
  font-size: 40px;
  font-weight: bolder;
}
.keyword-lighten {
  color: #000;
  background-color: #ffff00;
}
.downloadbutton {
  background-color: aqua;
  border-color: black;
  padding: 3px 3px;
}
.card-container {
  background: #f5f5f5;
  overflow: hidden;
  padding: 4px;
}
</style>
